import { InstitutionIntegrationType } from '@breakoutlearning/firebase-repository/types'

const supportEmail = 'support@breakoutlearning.com'

const lmsNames: Record<InstitutionIntegrationType, string> = {
  [InstitutionIntegrationType.canvas]: 'Canvas',
  [InstitutionIntegrationType.d2l]: 'D2L',
  [InstitutionIntegrationType.blackboard]: 'Blackboard',
  [InstitutionIntegrationType.generic]: 'LTI',
}

/**
 * Builds the `mailto:` link behind Contact Support on the LTI error page.
 * Every field Support asked for is filled in when the page knows it; the rest
 * say "Unknown" so the email keeps a fixed shape they can scan. The user's
 * email is unknown when sign-in itself failed, or when the server redirected
 * here before the app loaded; Support then falls back to the sender address.
 */
export function buildSupportMailto({
  userEmail,
  ltiMode,
  sectionId,
  organizationId,
  placement,
  errorLines,
  now = new Date(),
}: {
  userEmail?: string | null
  ltiMode?: InstitutionIntegrationType
  sectionId?: string
  organizationId?: string
  placement?: string
  errorLines: string[]
  now?: Date
}) {
  const subject = `Breakout Login Error: ${userEmail || 'unknown user'}`
  const body = [
    'The following user encountered an error while attempting to launch Breakout Learning through their LMS.',
    '',
    `User Email: ${userEmail || 'Unknown (see sender address)'}`,
    `Error: ${errorLines.length > 0 ? errorLines.join(' | ') : 'Failed to log in to Breakout Learning.'}`,
    `LMS: ${ltiMode ? lmsNames[ltiMode] : 'Unknown'}`,
    `Section ID: ${sectionId || 'Unknown'}`,
    `Organization ID: ${organizationId || 'Unknown'}`,
    `Placement: ${placement || 'Unknown'}`,
    `Time: ${now.toISOString()}`,
  ].join('\r\n')

  // encodeURIComponent, not URLSearchParams: the latter encodes spaces as
  // "+", which mail clients show literally.
  return `mailto:${supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}
